import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { OperationsTeam } from "../../types/operationsTeam";
import { getOperationsTeamsApi } from "../../api/operationsTeamsApi";

interface OperationsTeamState {
  operationsTeams: OperationsTeam[];
  loading: boolean;
  error: string | null;
}

const initialState: OperationsTeamState = {
  operationsTeams: [],
  loading: false,
  error: null,
};

export const fetchOperationsTeams = createAsyncThunk<
  OperationsTeam[],
  void,
  { rejectValue: string }
>("operationsTeams/fetchOperationsTeams", async (_, { rejectWithValue }) => {
  try {
    return await getOperationsTeamsApi();
  } catch (error: any) {
    return rejectWithValue(error.response?.data?.message || "Failed to fetch operations teams");
  }
});

const operationsTeamSlice = createSlice({
  name: "operationsTeams",
  initialState,
  reducers: {
    clearOperationsTeamsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOperationsTeams.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOperationsTeams.fulfilled, (state, action: PayloadAction<OperationsTeam[]>) => {
        state.loading = false;
        state.operationsTeams = action.payload;
      })
      .addCase(fetchOperationsTeams.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch operations teams";
      });
  },
});

export const { clearOperationsTeamsError } = operationsTeamSlice.actions;
export default operationsTeamSlice.reducer;
